import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
} from '@material-ui/core';

import { formatRoute } from 'react-router-named-routes';

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

const searchFormTabs = (props) => {
  return (
    <div className={classes.searchTabsWrapper}>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.SEARCH_FORM, { type: 'by-criteria' })}>
        <Button
          variant="outlined"
          className={props.type === 'by-criteria' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Search by Criteria
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.SEARCH_FORM, { type: 'by-id' })}>
        <Button
          variant="outlined"
          className={props.type === 'by-id' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Search by ID
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.SEARCH_FORM, { type: 'by-name' })}>
        <Button
          variant="outlined"
          className={props.type === 'by-name' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Search by Name
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.SAVED_SEARCHES)}>
        <Button
          variant="outlined"
          className={props.type === 'saved' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Saved Searches
        </Button>
      </Link>
    </div>
  );
};

export default searchFormTabs;



// WEBPACK FOOTER //
// ./src/search/components/SearchFormTabs.js